export default __webpack_public_path__ + "206e849d8d0913698ab6ae7e76c1917a.webp";